export default __webpack_public_path__ + "static/media/germany.7327578f.svg";